import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";

import HeroSection from "./HeroSection";

const AISection = lazy(() => import("./AISection"));
const WorkSection = lazy(() => import("./WorkSection"));
const InfluenceSection = lazy(() => import("./InfluenceSection"));
const InnovationSection = lazy(() => import("./InnovationSection"));

const AIServices = () => {
  return (
    <>
      <Helmet>
        <title>
          AI Solutions | AI Integration & Automation by Lentera Technologies
        </title>
        <meta
          name="description"
          content="Lentera Technologies delivers AI solutions with machine learning, automation, chatbots, analytics and recognition to enhance user experience and efficiency."
        />
        <meta
          name="keywords"
          content="AI solutions, Lentera Technologies, AI integration, machine learning, AI automation, chatbot solutions, AI analytics, voice recognition, image recognition."
        />
      </Helmet>

      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <section className="bg-black text-white font-poppins py-8 md:py-12 xl:py-20 px-4 md:px-8 xl:px-16 flex flex-col items-center">
          <AISection />
          <WorkSection />
          <InfluenceSection />
          <InnovationSection />
        </section>
      </Suspense>
    </>
  );
};


export default AIServices;
